module.exports = __webpack_public_path__ + "media/proksee-viewer/images/icon-refresh-42cf1d0caba73e15d88afd25bfaf4223.png";